import CacheManagement from "../../../components/cache-management/cache-management";
import Page from "../../page";

const CachePage = () => (
  <Page>
    <CacheManagement />
  </Page>
);

export default CachePage;
